/* ══════════════════════════════════════════════════════
   Collection Quick-Add  –  JS
   Bottom-sheet popup with color + size selection
   ══════════════════════════════════════════════════════ */
(function () {
  /* Boot with jQuery retry – guarantees jQuery is available */
  function boot() {
    if (!window.jQuery) { setTimeout(boot, 80); return; }
    var $ = jQuery;
    var _cache = {};
    var _prefetching = {}; /* track in-flight prefetch promises by handle */

    /* ── Prefetch a product into _cache (parallel .js + HTML) ── */
    function prefetch(handle) {
      if (_cache[handle] || _prefetching[handle]) return _prefetching[handle] || $.Deferred().resolve(_cache[handle]).promise();
      var dfd = $.Deferred();
      _prefetching[handle] = dfd.promise();
      var encodedHandle = encodeURIComponent(handle);
      var jsonReq = $.getJSON('/products/' + encodedHandle + '.js');
      var htmlReq = $.get('/products/' + encodedHandle + '?view=quick-add');
      $.when(jsonReq, htmlReq).done(function (jsonResp, htmlResp) {
        var p = jsonResp[0];
        var html = htmlResp[0];
        var inv = {};
        try {
          var m = html.match(/window\.__variantInventory\s*=\s*(\{[\s\S]*?\});/);
          if (m && m[1]) inv = JSON.parse(m[1].replace(/\s+/g, ' '));
        } catch (e) {}
        p._inv = inv;
        try {
          var storedInv = JSON.parse(sessionStorage.getItem('__variantInventoryAll') || '{}');
          Object.keys(inv || {}).forEach(function(variantId) {
            storedInv[String(variantId)] = inv[variantId];
          });
          sessionStorage.setItem('__variantInventoryAll', JSON.stringify(storedInv));
        } catch (invErr) {}
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var tpl = doc.getElementById('CartMetafieldRecommendationsTemplate');
          p._cartRecommendationsHtml = tpl && tpl.innerHTML ? tpl.innerHTML : '';
        } catch (e2) {
          p._cartRecommendationsHtml = '';
        }
        _cache[handle] = p;
        delete _prefetching[handle];
        dfd.resolve(p);
      }).fail(function () {
        /* If the HTML req fails, try with just the JSON */
        jsonReq.done(function (p) {
          p._inv = {};
          p._cartRecommendationsHtml = '';
          _cache[handle] = p;
          delete _prefetching[handle];
          dfd.resolve(p);
        }).fail(function () {
          delete _prefetching[handle];
          dfd.reject();
        });
      });
      return dfd.promise();
    }

    /* ── Text strings from data attributes ── */
    var _popup = document.getElementById('CqaPopup');
    var TXT_EMPTY   = _popup ? (_popup.getAttribute('data-txt-empty')   || '\u041d\u044f\u043c\u0430 \u043d\u0430\u043b\u0438\u0447\u043d\u0438 \u0440\u0430\u0437\u043c\u0435\u0440\u0438') : '\u041d\u044f\u043c\u0430 \u043d\u0430\u043b\u0438\u0447\u043d\u0438 \u0440\u0430\u0437\u043c\u0435\u0440\u0438';
    var TXT_ADDED   = _popup ? (_popup.getAttribute('data-txt-added')   || '\u0414\u043e\u0431\u0430\u0432\u0435\u043d\u043e \u0432 \u043a\u043e\u0448\u043d\u0438\u0446\u0430\u0442\u0430') : '\u0414\u043e\u0431\u0430\u0432\u0435\u043d\u043e \u0432 \u043a\u043e\u0448\u043d\u0438\u0446\u0430\u0442\u0430';
    var TXT_SOLDOUT = _popup ? (_popup.getAttribute('data-txt-soldout') || '\u0418\u0437\u0447\u0435\u0440\u043f\u0430\u043d') : '\u0418\u0437\u0447\u0435\u0440\u043f\u0430\u043d';
    var TXT_ERROR   = _popup ? (_popup.getAttribute('data-txt-error')   || '\u0413\u0440\u0435\u0448\u043a\u0430') : '\u0413\u0440\u0435\u0448\u043a\u0430';
    var TXT_LOW_STOCK = _popup ? (_popup.getAttribute('data-txt-low-stock') || '\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438 \u0431\u0440\u043e\u0439\u043a\u0438') : '\u041f\u043e\u0441\u043b\u0435\u0434\u043d\u0438 \u0431\u0440\u043e\u0439\u043a\u0438';
    var TXT_NOTIFY   = _popup ? (_popup.getAttribute('data-txt-notify')     || '\u0423\u0432\u0435\u0434\u043e\u043c\u0435\u0442\u0435 \u043c\u0435 \u043f\u0440\u0438 \u043d\u0430\u043b\u0438\u0447\u043d\u043e\u0441\u0442') : '\u0423\u0432\u0435\u0434\u043e\u043c\u0435\u0442\u0435 \u043c\u0435 \u043f\u0440\u0438 \u043d\u0430\u043b\u0438\u0447\u043d\u043e\u0441\u0442';
    var TXT_ADD_SINGLE = _popup ? (_popup.getAttribute('data-txt-add-single') || '+ \u0414\u043e\u0431\u0430\u0432\u0438') : '+ \u0414\u043e\u0431\u0430\u0432\u0438';

    /* ── Parse admin color-hex map from data attribute ── */
    var _colorMapRaw = _popup ? (_popup.getAttribute('data-color-map') || '') : '';
    var _colorHexMap = {};
    if (_colorMapRaw) {
      _colorMapRaw.split(/\n|<br\s*\/?>/).forEach(function (line) {
        line = line.trim();
        if (!line) return;
        var idx = line.indexOf(':');
        if (idx < 1) return;
        var name = line.substring(0, idx).trim().toLowerCase();
        var val  = line.substring(idx + 1).trim();
        if (val) _colorHexMap[name] = val;
      });
    }

    /* ── Helpers ── */
    function fmtMoney(c) {
      return (c / 100).toFixed(2) + ' \u20ac';
    }
    function fmtBGN(c) {
      return (c / 100 * 1.95583).toFixed(2) + ' \u043b\u0432';
    }
    function price(c) { return fmtMoney(c) + ' / ' + fmtBGN(c); }

    /* ── Detect color option index ── */
    function colorIdx(p) {
      var n = ['color','colour','\u0446\u0432\u044f\u0442','\u0446\u0432\u0435\u0442\u043e\u0432\u0435'];
      for (var i = 0; i < p.options.length; i++) {
        var opt = p.options[i];
        var name = (typeof opt === 'string' ? opt : (opt.name || '')).toLowerCase();
        if (n.indexOf(name) !== -1) return i;
      }
      return -1;
    }

    /* ── Size option index (first non-color option) ── */
    function sizeIdx(p, ci) {
      for (var i = 0; i < p.options.length; i++) { if (i !== ci) return i; }
      return -1;
    }

    /* ── Unique colors with variant image ── */
    function uniqueColors(p, ci) {
      var seen = {}, out = [];
      p.variants.forEach(function (v) {
        var c = v.options[ci];
        if (!seen[c]) {
          seen[c] = true;
          var img = null;
          p.variants.forEach(function (vv) {
            if (!img && vv.options[ci] === c && vv.featured_image) img = vv.featured_image.src;
          });
          out.push({ name: c, image: img });
        }
      });
      return out;
    }

    /* ── Check if product should add directly (no meaningful options to choose) ── */
    function shouldAddDirectly(p) {
      var ci = colorIdx(p), si = sizeIdx(p, ci);
      /* Only 1 variant total with no color/size options → direct add or soldout */
      if (p.variants.length === 1 && ci === -1 && si === -1) {
        return p.variants[0].available ? p.variants[0] : null;
      }
      /* Color-only product (no size option) with a single unique color →
         direct add instead of opening an empty popup */
      if (ci !== -1 && si === -1) {
        var colors = uniqueColors(p, ci);
        if (colors.length === 1) {
          var avail1 = p.variants.filter(function (v) { return v.available; });
          return avail1.length ? avail1[0] : null;
        }
      }
      /* Has color/size options → always show popup (even if all sold out,
         so user can see "notify me" buttons per size) */
      if (ci !== -1 || si !== -1) return false;
      /* No meaningful options */
      var avail = p.variants.filter(function (v) { return v.available; });
      if (avail.length === 0) return null;
      return avail[0];
    }

    var LOW_STOCK_THRESHOLD = _popup ? (parseInt(_popup.getAttribute('data-low-stock-threshold'), 10) || 2) : 2;

    function deliveryNoteFromProduct(p) {
      var tags = (p && p.tags) || [];
      if (typeof tags === 'string') tags = tags.split(',');
      for (var i = 0; i < tags.length; i++) {
        var tag = String(tags[i] || '').trim();
        if (tag.indexOf('delivery_note_') === 0) return tag.substring(14).trim();
      }
      return '';
    }

    function cartDataWithDeliveryNote(baseData, p) {
      var data = baseData || {};
      var note = deliveryNoteFromProduct(p);
      if (note) {
        data.properties = data.properties || {};
        data.properties._delivery_note = note;
      }
      return data;
    }

    /* ── Render size options as Reformation-style panel rows ── */
    function renderSizes(p, ci, si, col) {
      var vs = p.variants.filter(function (v) {
        return ci === -1 || v.options[ci] === col;
      });
      var inv = p._inv || {};
      var h = '';
      if (vs.length === 0) {
        h = '<div class="cqa-popup__empty">' + TXT_EMPTY + '</div>';
      } else if (vs.length === 1 && ci === -1) {
        if (vs[0].available) {
          var tag1 = '';
          var info1 = inv[String(vs[0].id)];
          if (info1 && info1.qty > 0 && info1.qty <= LOW_STOCK_THRESHOLD) {
            tag1 = '<span class="cqa-panel__option-tag">' + TXT_LOW_STOCK + '</span>';
          }
          h += '<div class="cqa-panel__option" data-variant-id="' + vs[0].id + '">' +
               '<span class="cqa-panel__option-label">' + TXT_ADD_SINGLE + '</span>' + tag1 + '</div>';
        } else {
          h += '<div class="cqa-panel__option cqa-panel__option--unavailable" data-size="One Size">' +
               '<span class="cqa-panel__option-label cqa-panel__option-strike">One Size</span>' +
               '<button type="button" class="cqa-panel__option-inquiry" data-size="One Size"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 4L12 13 2 4"/></svg> ' + TXT_NOTIFY + '</button></div>';
        }
      } else {
        vs.forEach(function (v) {
          var lbl = (si >= 0 ? v.options[si] : v.option1) || 'One Size';
          var cls = 'cqa-panel__option';
          var tag = '';
          if (!v.available) {
            cls += ' cqa-panel__option--unavailable';
          } else {
            var info = inv[String(v.id)];
            if (info && info.qty > 0 && info.qty <= LOW_STOCK_THRESHOLD) {
              tag = '<span class="cqa-panel__option-tag">' + TXT_LOW_STOCK + '</span>';
            }
          }
          h += '<div class="' + cls + '" data-variant-id="' + v.id + '"';
          if (!v.available) h += ' data-unavailable="1"';
          if (!v.available) h += ' data-size="' + lbl + '"';
          var inquiry = '';
          if (!v.available) {
            inquiry = '<button type="button" class="cqa-panel__option-inquiry" data-size="' + lbl + '"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M22 4L12 13 2 4"/></svg> ' + TXT_NOTIFY + '</button>';
          }
          h += '><span class="cqa-panel__option-label' + (!v.available ? ' cqa-panel__option-strike' : '') + '">' + lbl + '</span>' + tag + inquiry + '</div>';
        });
      }
      $('#CqaPopupSizes').html(h);
      /* Append razmer_ tag note if present */
      var razmerNote = '';
      if (p.tags && p.tags.length) {
        for (var t = 0; t < p.tags.length; t++) {
          if (p.tags[t].indexOf('razmer_') === 0) {
            razmerNote = p.tags[t].substring(7);
            break;
          }
        }
      }
      if (razmerNote) {
        $('#CqaPopupSizes').append('<div class="cqa-panel__note">' + razmerNote + '</div>');
      }
      var deliveryNote = deliveryNoteFromProduct(p);
      if (deliveryNote) {
        $('<div class="cqa-panel__delivery-note"></div>').text(deliveryNote).appendTo('#CqaPopupSizes');
      }
    }

    /* ── Collect images for a color ──
       Logic: build a map image→color from variants. Find the first image
       of the selected color in p.images, then walk forward collecting
       images until we hit one that belongs to a DIFFERENT color.
       Images with no color mapping are included (shared/lifestyle shots). ── */

    /* Normalize Shopify CDN URL to just the path portion for reliable comparison */
    function normSrc(src) {
      if (!src) return '';
      /* Strip protocol + domain, query string, and size suffixes */
      var s = src.replace(/^https?:/, '').replace(/^\/\/[^\/]+/, '').split('?')[0];
      /* Remove any Shopify size suffix like _200x, _100x100, _grande etc */
      s = s.replace(/_(?:\d+x\d*|\d*x\d+|pico|icon|thumb|small|compact|medium|large|grande|original|master)(?=\.(jpg|jpeg|png|gif|webp))/i, '');
      return s;
    }

    function imagesForColor(p, ci, col) {
      if (!p.images || !p.images.length) return [];

      /* No color option → return all images */
      if (ci < 0 || !col) {
        return p.images.map(function (src) {
          return src.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_200x.$1');
        });
      }

      /* Build normalized image → color map (first color that claims the image wins) */
      var imgColor = {};
      p.variants.forEach(function (v) {
        if (v.featured_image && v.featured_image.src) {
          var n = normSrc(v.featured_image.src);
          if (!imgColor[n]) {
            imgColor[n] = v.options[ci];
          }
        }
      });

      /* Normalize product images for comparison */
      var normImages = p.images.map(function (src) { return normSrc(src); });

      /* Find the starting index: first image belonging to selected color */
      var startIdx = -1;
      for (var i = 0; i < normImages.length; i++) {
        if (imgColor[normImages[i]] === col) { startIdx = i; break; }
      }
      if (startIdx === -1) {
        /* Color not found in images, fall back to all */
        return p.images.map(function (src) {
          return src.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_200x.$1');
        });
      }

      /* Walk forward from startIdx: collect until we hit a DIFFERENT color */
      var result = [];
      for (var j = startIdx; j < p.images.length; j++) {
        var owner = imgColor[normImages[j]];
        if (owner && owner !== col) break; /* belongs to another color → stop */
        result.push(p.images[j].replace(/\.(jpg|jpeg|png|gif|webp)/i, '_200x.$1'));
      }

      return result;
    }

    /* ── Build image strip HTML + init drag ── */
    var _dragCleanup = null;
    function buildCarousel(imgs) {
      var $car = $('#CqaPopupCarousel');
      /* Tear down previous drag listeners */
      if (_dragCleanup) { _dragCleanup(); _dragCleanup = null; }
      if (!imgs || imgs.length === 0) { $car.hide(); return; }
      // Remove any old tracks
      $car.find('.cqa-car__track').remove();
      var h = '<div class="cqa-car__track" id="CqaCarTrack" style="display:flex">';
      imgs.forEach(function (src) {
        h += '<div class="cqa-car__slide"><img src="' + src + '" alt="" draggable="false"></div>';
      });
      h += '</div>';
      $car.html(h).show();
      /* Reset scroll to start so returning to a color doesn't show blank */
      $car[0].scrollLeft = 0;
      // Force flex display in case CSS fails
      $car.find('.cqa-car__track').css('display','flex');
      if (imgs.length > 1) initStripDrag();
    }

    function updateInquiryViewportOffset() {
      var offset = 0;
      try {
        if (window.visualViewport) {
          var vv = window.visualViewport;
          offset = Math.max(0, Math.round((window.innerHeight || 0) - vv.height - vv.offsetTop));
        }
      } catch (e) {
        offset = 0;
      }
      document.documentElement.style.setProperty('--cqa-inquiry-vv-offset', offset + 'px');
    }

    updateInquiryViewportOffset();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', updateInquiryViewportOffset, { passive: true });
      window.visualViewport.addEventListener('scroll', updateInquiryViewportOffset, { passive: true });
    }
    window.addEventListener('resize', updateInquiryViewportOffset, { passive: true });
    window.addEventListener('orientationchange', updateInquiryViewportOffset, { passive: true });

    /* ── Mouse/touch drag for the scrollable strip ── */
    function initStripDrag() {
      var el = document.getElementById('CqaPopupCarousel');
      if (!el) return;
      var isDown = false, startX = 0, scrollL = 0;
      function onDown(e) {
        isDown = true; startX = e.pageX - el.offsetLeft; scrollL = el.scrollLeft;
        el.classList.add('cqa-car--dragging');
      }
      function onUp() {
        if (!isDown) return; isDown = false;
        el.classList.remove('cqa-car--dragging');
      }
      function onMove(e) {
        if (!isDown) return;
        var x = e.pageX - el.offsetLeft;
        el.scrollLeft = scrollL - (x - startX);
      }
      el.addEventListener('mousedown', onDown);
      document.addEventListener('mouseup', onUp);
      document.addEventListener('mousemove', onMove);
      /* Store cleanup so we remove listeners before next rebuild */
      _dragCleanup = function () {
        el.removeEventListener('mousedown', onDown);
        document.removeEventListener('mouseup', onUp);
        document.removeEventListener('mousemove', onMove);
      };
    }

    /* ── Open popup ── */
    function open(p, curColor, thumb) {
      var ci = colorIdx(p), si = sizeIdx(p, ci);

      /* Title & Wishlist Data */
      $('#CqaPopupTitle').text(p.title);
      var $wlBtn = $('#CqaWishlistBtn');
      if ($wlBtn.length) {
        var firstVideo = '';
        if (p.media && p.media.length) {
          for (var mi = 0; mi < p.media.length; mi++) {
            if (p.media[mi].media_type === 'video') {
              var srcs = p.media[mi].sources;
              if (srcs && srcs.length) { firstVideo = srcs[0].url; }
              break;
            }
          }
        }
        var thumbImg = thumb ? thumb.replace(/_200x(\.[a-z0-9]+)$/i, '_400x$1') : (p.featured_image ? p.featured_image : '');
        $wlBtn.attr({
          'data-wl-handle': p.handle || '',
          'data-wl-color': curColor || '',
          'data-wl-title': p.title || '',
          'data-wl-img': thumbImg,
          'data-wl-video': firstVideo,
          'data-wl-url': '/products/' + p.handle,
          'data-wl-price': p.price || ''
        });
        if (window.VerychiWishlist && typeof window.VerychiWishlist.syncAll === 'function') {
          setTimeout(function() { window.VerychiWishlist.syncAll(); }, 10);
        }
      }

      /* Price */
      $('#CqaPopupPrice').html(price(p.price));

      /* Carousel */
      var active = curColor || (ci >= 0 ? uniqueColors(p, ci)[0].name : null);
      var carImgs = imagesForColor(p, ci, active);
      buildCarousel(carImgs);

      /* Colors */
      if (ci >= 0) {
        var cols = uniqueColors(p, ci);
        if (cols.length > 1) {
          var ch = '';
          cols.forEach(function (c) {
            var act = c.name === curColor ? ' cqa-popup__swatch--active' : '';
            var cLower = c.name.toLowerCase().trim();
            var hex = _colorHexMap[cLower] || '';
            var style = '';
            if (hex) {
              style = 'background-color:' + hex;
            } else if (c.image) {
              style = 'background-image:url(' + c.image.replace(/\.([a-z]+)\?/, '_80x80_crop_center.$1?') + ');background-size:cover;background-position:center';
            } else {
              style = 'background-color:#ccc';
            }
            ch += '<button class="cqa-popup__swatch' + act + '" data-color="' + c.name +
                  '" style="' + style + '" title="' + c.name + '"></button>';
          });
          $('#CqaPopupColors').html(ch).show();
          $('#CqaColorLabel').show().html('\u0426\u0432\u044f\u0442: <span id="CqaColorName">' + (curColor || cols[0].name) + '</span>');
        } else {
          $('#CqaPopupColors').hide(); $('#CqaColorLabel').hide();
        }
      } else {
        $('#CqaPopupColors').hide(); $('#CqaColorLabel').hide();
      }

      /* Sizes */
      var dynamicSizeGuideHtml = '';
      if (p.description) {
        var configTag = (window.SizeGuideConfig && window.SizeGuideConfig.tag) || 'SIZE_GUIDE';
        var tagRegex = new RegExp('\\[' + configTag + '\\]([\\s\\S]*?)(?:\\[\\/' + configTag + '\\]|$)', 'i');
        var match = p.description.match(tagRegex);
        if (match) {
          dynamicSizeGuideHtml = match[1];
        }
      }
      p._sizeGuideHtml = dynamicSizeGuideHtml;

      if (si >= 0) {
        renderSizes(p, ci, si, active);
        $('.cqa-popup__size-group').show();
        $('#CqaSizeGuideTop').show();
      } else {
        /* No size option (color-only) — hide panel and size guide */
        $('.cqa-popup__size-group').hide();
        $('#CqaSizeGuideTop').hide();
      }

      /* Size guide link — visible only when product has sizes */

      /* Store state */
      var $pp = $('#CqaPopup');
      $pp.data({ 'cqa-p': p, 'cqa-ci': ci, 'cqa-si': si });

      $('#CqaOverlay').addClass('cqa-overlay--visible');
      /* Lock body scroll (iOS-safe: position:fixed preserves scrollY) */
      var scrollY = window.scrollY || window.pageYOffset || 0;
      document.body.setAttribute('data-cqa-scroll', scrollY);
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
      $pp[0].offsetHeight; /* force reflow */
      $pp.addClass('cqa-popup--visible');
    }

    /* ── Close ── */
    function close() {
      var $pp = $('#CqaPopup');
      $pp.removeClass('cqa-popup--visible');
      $('#CqaInquiryPanel').removeClass('cqa-inquiry--visible');
      /* Wait for slide-out animation, THEN restore body scroll */
      setTimeout(function () {
        $pp.css('transform', '');
        $('#CqaOverlay').removeClass('cqa-overlay--visible');
        /* Unlock body scroll & restore position */
        var savedY = parseInt(document.body.getAttribute('data-cqa-scroll') || '0', 10);
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.overflow = '';
        window.scrollTo(0, savedY);
      }, 320);
    }

    /* ── Toast ── */
    function toast(msg) {
      var $t = $('#CqaToast');
      $t.text(msg).addClass('cqa-toast--visible');
      setTimeout(function () { $t.removeClass('cqa-toast--visible'); }, 1800);
    }

    /* ── Update header cart count ── */
    function keepCartDrawerOpen() {
      if (typeof ajaxCart === 'undefined' || !ajaxCart.load) return;

      if (window.timber && timber.RightDrawer) {
        if (timber.RightDrawer.drawerIsOpen) {
          ajaxCart.load();
        } else {
          timber.RightDrawer.open();
        }
        return;
      }

      if (typeof ajaxCart !== 'undefined' && ajaxCart.load) {
        ajaxCart.load();
        document.documentElement.classList.add('js-drawer-open', 'js-drawer-open-right');
        document.body.classList.add('js-drawer-open', 'js-drawer-open-right');
        var drawer = document.getElementById('CartDrawer');
        if (drawer) drawer.classList.add('js-drawer-open');
      }
    }

    function refreshCart(keepDrawer) {
      $.getJSON('/cart.js', function (c) {
        $('.cart-link__count, .site-header__cart-count, [data-cart-count]').text(c.item_count);
        if (c.item_count > 0) $('.cart-link__bubble').addClass('cart-link__bubble--visible');
        if (keepDrawer || document.body.classList.contains('js-drawer-open-right')) {
          keepCartDrawerOpen();
        }
      });
    }

    function queueCartRecommendationsFromProduct(p) {
      if (!p || !p._cartRecommendationsHtml || !p._cartRecommendationsHtml.trim()) return;
      window.__CartMetafieldRecommendationsHtml = p._cartRecommendationsHtml;
      window.__CartMetafieldRecommendationsPending = true;
      try {
        sessionStorage.setItem('verychiCartRecommendationsHtml', p._cartRecommendationsHtml);
      } catch (err) {}
      try {
        localStorage.setItem('verychiCartRecommendationsHtml', p._cartRecommendationsHtml);
        localStorage.setItem('verychiCartRecommendationsSavedAt', String(Date.now()));
      } catch (err2) {}
    }

    /* ══ Event bindings (run on DOM ready) ══ */
    $(function () {

      /* ── + button: CAPTURE PHASE listener (fires before any stopPropagation) ── */
      document.addEventListener('click', function (e) {
        var btn = e.target.closest('.collection-quick-add-btn, .cqa-desktop-btn');
        if (!btn) return;
        /* Desktop + button → handled by inline overlay script, not global popup */
        if (btn.classList.contains('cqa-desktop-btn') && window.innerWidth > 768) return;

        e.preventDefault();
        e.stopPropagation();

        var handle = btn.getAttribute('data-product-handle'),
            img    = btn.getAttribute('data-product-img'),
            color  = btn.getAttribute('data-current-color') || '',
            razmerNote = btn.getAttribute('data-razmer-note') || '';
        var openedFromCartRecommendations = !!btn.closest('#CartDrawer, .ajaxcart');

        if (!handle) { return; }

        /* Shared handler once product is loaded */
        function handleProduct(p) {
          btn.style.pointerEvents = '';
          p._openedFromCartRecommendations = openedFromCartRecommendations;
          var directV = shouldAddDirectly(p);
          if (directV) {
            $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json',
              data: cartDataWithDeliveryNote({ id: String(directV.id), quantity: 1 }, p),
              success: function () { queueCartRecommendationsFromProduct(p); refreshCart(p._openedFromCartRecommendations); toast(TXT_ADDED); },
              error: function (xhr) {
                var msg = TXT_ERROR;
                try { var b = JSON.parse(xhr.responseText); if (b.description) msg = b.description; } catch(ex){}
                toast(msg);
              }
            });
            return;
          }
          if (directV === null) { toast(TXT_SOLDOUT); return; }
          try { open(p, color, img, razmerNote); }
          catch (err) {}
        }

        /* Fast path: already cached */
        if (_cache[handle]) {
          handleProduct(_cache[handle]);
          return;
        }

        /* Parallel fetch via prefetch() */
        btn.style.pointerEvents = 'none';
        prefetch(handle)
          .done(function (p) { handleProduct(p); })
          .fail(function () {
            btn.style.pointerEvents = '';
            toast(TXT_ERROR);
          });

      }, true); /* ← true = capture phase */

      /* Color swatch → switch sizes OR add to cart (color-only) */
      $(document).on('click', '.cqa-popup__swatch', function (e) {
        e.stopPropagation();
        var $c = $(this), col = $c.attr('data-color');
        $('.cqa-popup__swatch').removeClass('cqa-popup__swatch--active');
        $c.addClass('cqa-popup__swatch--active');
        /* Update color name label & Wishlist button config */
        $('#CqaColorName').text(col);
        var $wlBtn = $('#CqaWishlistBtn');
        if ($wlBtn.length) {
          $wlBtn.attr('data-wl-color', col);
          if (window.VerychiWishlist && typeof window.VerychiWishlist.syncAll === 'function') {
            window.VerychiWishlist.syncAll();
          }
        }

        var $pp = $('#CqaPopup'), p = $pp.data('cqa-p'), ci = $pp.data('cqa-ci'), si = $pp.data('cqa-si');
        /* Update carousel for new color */
        var carImgs = imagesForColor(p, ci, col);
        buildCarousel(carImgs);

        /* Color-only product (no size option) → add to cart directly */
        if (si < 0) {
          var variant = null;
          p.variants.forEach(function (v) {
            if (v.options[ci] === col && v.available) variant = v;
          });
          if (!variant) { toast(TXT_SOLDOUT); return; }
          if ($c.hasClass('cqa-popup__swatch--adding')) return;
          $c.addClass('cqa-popup__swatch--adding');
          $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json',
            data: cartDataWithDeliveryNote({ id: String(variant.id), quantity: 1 }, p),
            success: function () {
              queueCartRecommendationsFromProduct(p);
              $c.removeClass('cqa-popup__swatch--adding');
              refreshCart(p && p._openedFromCartRecommendations); toast(TXT_ADDED);
              setTimeout(close, 800);
            },
            error: function (xhr) {
              $c.removeClass('cqa-popup__swatch--adding');
              var msg = TXT_ERROR;
              try { var b = JSON.parse(xhr.responseText); if (b.description) msg = b.description; } catch(ex){}
              toast(msg);
            }
          });
          return;
        }

        renderSizes(p, ci, si, col);
      });

      /* Overlay click or Close Button → close */
      $('#CqaOverlay, #CqaPopupClose').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        close();
      });

      /* Size guide styling & tab logic globally */
      window.parseSimpleSizeGuideSyntax = function(text) {
        var html = '';
        var lines = text.split('\n');
        var inTable = false;
        
        for (var i = 0; i < lines.length; i++) {
          var line = (lines[i] || '').trim();
          if (!line) continue;
          
          /* If line starts with #, treat as Tab Title (h5) */
          if (line.charAt(0) === '#') {
            if (inTable) { html += '</tbody></table>'; inTable = false; }
            html += '<h5>' + line.substring(1).trim() + '</h5>';
          } 
          /* If line contains |, treat as Markdown Table row */
          else if (line.indexOf('|') > -1) {
            /* Skip separator lines like |---|---| */
            if (line.replace(/[|\s-]/g, '') === '') continue;
            
            var cells = line.split('|');
            /* Remove empty first/last elements if line starts/ends with | */
            if (cells.length > 0 && (cells[0] || '').trim() === '') cells.shift();
            if (cells.length > 0 && (cells[cells.length-1] || '').trim() === '') cells.pop();
            
            if (!inTable) {
              html += '<table><thead><tr>';
              for (var c=0; c<cells.length; c++) { html += '<th>' + (cells[c] || '').trim() + '</th>'; }
              html += '</tr></thead><tbody>';
              inTable = true;
            } else {
              html += '<tr>';
              for (var c=0; c<cells.length; c++) { html += '<td>' + (cells[c] || '').trim() + '</td>'; }
              html += '</tr>';
            }
          }
          /* Treat as image if starts with http and ends with jpg/png/gif */
          else if (/^https?:.*\.(jpg|jpeg|png|gif|webp)(\?.*)?$/i.test(line)) {
            if (inTable) { html += '</tbody></table>'; inTable = false; }
            html += '<img src="' + line + '">';
          }
          /* Normal text paragraph */
          else {
            if (inTable) { html += '</tbody></table>'; inTable = false; }
            /* Don't wrap existing HTML tags in p */
            if (line.charAt(0) === '<') html += line;
            else html += '<p>' + line + '</p>';
          }
        }
        if (inTable) { html += '</tbody></table>'; }
        return html;
      };

      window.openDynamicSizeGuide = function(rawHtml) {
        if (window.__verychiEnsureProductHiddenUi) window.__verychiEnsureProductHiddenUi();
        var $inner = $('#CqaSizeGuideModalInner');
        if (!$inner.length) return;
        var html = (rawHtml || '').trim();
        if (!html) {
          /* Restore default */
          $inner.attr('data-size-guide-mode', 'default-pending');
          if (window.__verychiEnsureDefaultSizeGuide) {
            window.__verychiEnsureDefaultSizeGuide();
          } else {
            var defaultSizeGuide = document.getElementById('DefaultSizeGuideData');
            $inner.html(defaultSizeGuide ? defaultSizeGuide.innerHTML : '');
          }
        } else {
          $inner.attr('data-size-guide-mode', 'dynamic');
          /* If there's no HTML tags like <h5> or <table>, try parsing simplified syntax */
          if (html.indexOf('<h5') === -1 && html.indexOf('<table') === -1) {
            /* We replace any HTML `<br>` or `<p>` artifacts back to newlines first */
            var plainText = html.replace(/&nbsp;/gi, ' ')
                                .replace(/<br\s*\/?>/gi, '\n')
                                .replace(/<\/p>/gi, '\n')
                                .replace(/<p>/gi, '')
                                .replace(/<\/div>/gi, '\n')
                                .replace(/<div>/gi, '')
                                .replace(/<[^>]+>/g, ''); 

            html = window.parseSimpleSizeGuideSyntax(plainText);
          }
          
          /* Parse dynamic HTML */
          var $temp = $('<div>').html(html);
          var $headings = $temp.find('h5');
          if ($headings.length > 0) {
            var tabsHtml = '<div class="cqa-size-guide-tabs">';
            var contentHtml = '<div class="cqa-size-guide-tab-contents">';
            
            $headings.each(function(i) {
              var title = $(this).text();
              var $contentNodes = $(this).nextUntil('h5');
              var contentChunk = $('<div>').append($contentNodes.clone()).html();
              
              tabsHtml += '<button type="button" class="cqa-sg-tab-btn' + (i===0?' active':'') + '" data-sg-tab="' + i + '">' + title + '</button>';
              contentHtml += '<div class="cqa-sg-tab-pane' + (i===0?' active':'') + '" data-sg-pane="' + i + '">' + contentChunk + '</div>';
            });
            tabsHtml += '</div>';
            contentHtml += '</div>';
            $inner.html(tabsHtml + contentHtml);
          } else {
            /* Fallback if no headings found */
            $inner.html('<div class="cqa-size-guide-modal__content">' + html + '</div>');
          }

          /* --- Size Filter Logic --- */
          var $targetPane = $inner.find('.cqa-sg-tab-pane').first();
          var $container = $targetPane.length ? $targetPane : $inner;
          var $table = $container.find('table').first();
          
          if ($table.length) {
            var sizes = [];
            // Skip the first row if it's a header
            $table.find('tr').each(function(i) {
              var $firstCell = $(this).find('td, th').first();
              var text = $firstCell.text().trim();
              
              if (i === 0 || $firstCell.is('th')) return;
              if (text && sizes.indexOf(text) === -1) sizes.push(text);
            });

            if (sizes.length > 0) {
              var filterTitle = (window.SizeGuideConfig && window.SizeGuideConfig.filterTitle) || 'ИЗБЕРЕТЕ РАЗМЕР';
              var filterHtml = '<div class="cqa-sg-filter"><span class="cqa-sg-filter__title">' + filterTitle + '</span><div class="cqa-sg-filter__btns">';
              sizes.forEach(function(s) {
                filterHtml += '<button type="button" class="cqa-sg-filter-btn" data-size="' + s + '">' + s + '</button>';
              });
              filterHtml += '</div></div>';
              $table.before(filterHtml);
            }
          }
        }
        $('#CqaSizeGuideOverlay').addClass('cqa-size-guide-overlay--visible');
        $('#CqaSizeGuideModal').addClass('cqa-size-guide-modal--visible');
        $('#StickyMobileATC').addClass('sticky-mobile-atc--popup-open');
        
        /* Lock body scroll */
        var scrollY = window.scrollY || window.pageYOffset || 0;
        document.body.setAttribute('data-cqa-sg-scroll', scrollY);
        
        /* Lock both html and body to be safe */
        var lockStyles = {
            position: 'fixed',
            top: '-' + scrollY + 'px',
            left: '0',
            right: '0',
            overflow: 'hidden',
            width: '100%'
        };
        Object.assign(document.body.style, lockStyles);
        document.documentElement.style.overflow = 'hidden';
      };

      /* Size guide tab click handler */
      $(document).on('click', '.cqa-sg-tab-btn', function(e) {
        e.preventDefault();
        var index = $(this).attr('data-sg-tab');
        $('.cqa-sg-tab-btn').removeClass('active');
        $(this).addClass('active');
        $('.cqa-sg-tab-pane').removeClass('active');
        $('.cqa-sg-tab-pane[data-sg-pane="' + index + '"]').addClass('active');
      });

      /* Size filter click handler */
      $(document).on('click', '.cqa-sg-filter-btn', function(e) {
        e.preventDefault();
        var size = $(this).attr('data-size');
        var isActive = $(this).hasClass('active');
        
        $('.cqa-sg-filter-btn').removeClass('active');
        var $modal = $('#CqaSizeGuideModal');
        var $table = $modal.find('table').first();
        
        if (isActive) {
          /* Reset filter */
          $table.removeClass('is-filtered');
          $table.find('tr').removeClass('cqa-sg-row--highlight');
        } else {
          $(this).addClass('active');
          $table.addClass('is-filtered');
          $table.find('tr').removeClass('cqa-sg-row--highlight');
          $table.find('tr').each(function() {
            var rowSize = $(this).find('td, th').first().text().trim();
            if (rowSize === size) {
              $(this).addClass('cqa-sg-row--highlight');
            }
          });
        }
      });

      /* Size guide link → open modal (both top link and in-panel link) */
      $(document).on('click', '#CqaSizeGuideTop, #CqaSizeGuide', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var p = $('#CqaPopup').data('cqa-p');
        var dynHtml = p && p._sizeGuideHtml ? p._sizeGuideHtml : $('#DynamicSizeGuideData').html();
        window.openDynamicSizeGuide(dynHtml);
      });
      $(document).off('click.cqaSizeGuideClose').on('click.cqaSizeGuideClose', '#CqaSizeGuideClose, #CqaSizeGuideOverlay', function () {
        $('#CqaSizeGuideOverlay').removeClass('cqa-size-guide-overlay--visible');
        $('#CqaSizeGuideModal').removeClass('cqa-size-guide-modal--visible');
        
        /* Unlock body scroll */
        var savedY = parseInt(document.body.getAttribute('data-cqa-sg-scroll') || '0', 10);
        
        document.documentElement.style.overflow = '';
        var unlockStyles = {
            position: '',
            top: '',
            left: '',
            right: '',
            overflow: '',
            width: ''
        };
        Object.assign(document.body.style, unlockStyles);
        
        window.scrollTo(0, savedY);
      });

      /* Inquiry click on unavailable size → show inline email form */
      $(document).on('click', '.cqa-panel__option--unavailable', function (e) {
        if ($(e.target).closest('.cqa-panel__option-inquiry').length) return;
        e.preventDefault();
        var $rowBtn = $(this).find('.cqa-panel__option-inquiry').first();
        if ($rowBtn.length) {
          $rowBtn.trigger('click');
          return;
        }
        var sizeVal = $(this).attr('data-size') || $(this).find('.cqa-panel__option-label').text().trim();
        if (!sizeVal) return;
        var $fallbackBtn = $('<button type="button" class="cqa-panel__option-inquiry"></button>').attr('data-size', sizeVal);
        $fallbackBtn.trigger('click');
      });

      $(document).on('click', '.cqa-panel__option-inquiry', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $pp = $('#CqaPopup');
        var p = $pp.data('cqa-p');
        var sizeVal = $(this).attr('data-size') || '';
        var ci = $pp.data('cqa-ci');
        var si = $pp.data('cqa-si');
        var curColor = '';
        if (ci >= 0) { curColor = $('#CqaColorName').text() || ''; }

        /* Find matching variant for SKU */
        var matchedVariant = null;
        if (p && p.variants) {
          p.variants.forEach(function(v) {
            if (si >= 0 && v.options[si] !== sizeVal) return;
            if (ci >= 0 && curColor && v.options[ci] !== curColor) return;
            matchedVariant = v;
          });
        }
        var sku = matchedVariant ? (matchedVariant.sku || '') : '';
        var variantTitle = matchedVariant ? matchedVariant.title : '';
        var priceStr = p ? price(p.price) : '';
        if (matchedVariant && matchedVariant.price) priceStr = price(matchedVariant.price);
        var productUrl = p ? ('{{ shop.url }}/products/' + p.handle) : '';
        if (matchedVariant) productUrl += '?variant=' + matchedVariant.id;

        /* Build subject line */
        var subj = '\u0423\u0432\u0435\u0434\u043e\u043c\u0435\u0442\u0435 \u043c\u0435 \u043f\u0440\u0438 \u043d\u0430\u043b\u0438\u0447\u043d\u043e\u0441\u0442 - ';
        subj += (p ? p.title : '');
        if (curColor) subj += ' / ' + curColor;
        if (sizeVal) subj += ' / ' + sizeVal;

        /* Build body with full details */
        var body = '\u041f\u0440\u043e\u0434\u0443\u043a\u0442: ' + (p ? p.title : '') + '\n';
        if (curColor) body += '\u0426\u0432\u044f\u0442: ' + curColor + '\n';
        if (sizeVal) body += '\u0420\u0430\u0437\u043c\u0435\u0440: ' + sizeVal + '\n';
        if (sku) body += 'SKU: ' + sku + '\n';
        if (priceStr) body += '\u0426\u0435\u043d\u0430: ' + priceStr + '\n';
        if (variantTitle) body += '\u0412\u0430\u0440\u0438\u0430\u043d\u0442: ' + variantTitle + '\n';
        body += '\u041b\u0438\u043d\u043a: ' + productUrl;

        var $inq = $('#CqaInquiryPanel');
        $inq.find('#CqaInquirySubject').val(subj);
        $inq.find('#CqaInquiryProductName').val(p ? p.title : '');
        $inq.find('#CqaInquiryColor').val(curColor);
        $inq.find('#CqaInquirySize').val(sizeVal);
        $inq.find('#CqaInquirySKU').val(sku);
        $inq.find('#CqaInquiryPrice').val(priceStr);
        $inq.find('#CqaInquiryProduct').val(productUrl);
        $inq.find('#CqaInquiryBody').val(body);
        $inq.find('#CqaInquiryEmail').val('');
        $inq.find('#CqaInquirySuccess').hide();
        $inq.find('#CqaInquiryForm').show();
        updateInquiryViewportOffset();
        $inq.addClass('cqa-inquiry--visible');
      });
      /* Close inquiry panel */
      $(document).on('click', '#CqaInquiryClose', function (e) {
        e.preventDefault();
        $('#CqaInquiryPanel').removeClass('cqa-inquiry--visible');
      });
      /* Submit inquiry form */
      $(document).on('submit', '#CqaInquiryForm', function (e) {
        e.preventDefault();
        var $form = $(this);
        var email = $('#CqaInquiryEmail').val().trim();
        if (!email) return;
        var $btn = $form.find('.cqa-inquiry__submit');
        $btn.prop('disabled', true).text('...');
        $.ajax({
          type: 'POST',
          url: '/contact',
          data: $form.serialize(),
          success: function () {
            $form.hide();
            $('#CqaInquirySuccess').show();
            $btn.prop('disabled', false).text('\u0418\u0417\u041f\u0420\u0410\u0422\u0418');
          },
          error: function () {
            $form.hide();
            $('#CqaInquirySuccess').show();
            $btn.prop('disabled', false).text('\u0418\u0417\u041f\u0420\u0410\u0422\u0418');
          }
        });
      });

      /* Size option tap → select like product page, then auto-add to cart */
      $(document).on('click', '.cqa-panel__option:not(.cqa-panel__option--unavailable)', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $b = $(this);
        if ($b.hasClass('cqa-panel__option--adding') || $b.hasClass('cqa-panel__option--added')) return;
        var p = $('#CqaPopup').data('cqa-p');
        var vid = $b.attr('data-variant-id');
        if (!vid) { toast(TXT_ERROR); return; }

        /* 1. Visual selection — same as product page */
        $('.cqa-panel__option').removeClass('cqa-panel__option--selected');
        $b.addClass('cqa-panel__option--selected');

        /* Auto-add to cart */
        setTimeout(function () {
          $b.addClass('cqa-panel__option--adding');
          $.ajax({ type: 'POST', url: '/cart/add.js', dataType: 'json',
            data: cartDataWithDeliveryNote({ id: vid, quantity: 1 }, p),
            success: function (resp) {
              queueCartRecommendationsFromProduct(p);
              $b.removeClass('cqa-panel__option--adding');
              refreshCart(p && p._openedFromCartRecommendations); toast(TXT_ADDED);
              setTimeout(close, 800);
            },
            error: function (xhr) {
              var msg = TXT_ERROR;
              try {
                var body = JSON.parse(xhr.responseText);
                if (body.description) msg = body.description;
              } catch (ex) {}
              $b.removeClass('cqa-panel__option--adding cqa-panel__option--selected');
              toast(msg);
            }
          });
        }, 350);
      });

      /* Swipe-down to close (works everywhere, carousel gets horiz scroll) */
      var sy = 0, sx = 0, cy = 0, swipeActive = false, swipeLocked = false, $pp = $('#CqaPopup');
      $pp.on('touchstart', function (e) {
        var t = e.originalEvent.touches[0];
        sy = cy = t.clientY;
        sx = t.clientX;
        swipeActive = false;
        swipeLocked = false;
        $pp.addClass('cqa-popup--dragging');
      });
      $pp.on('touchmove', function (e) {
        if ($(e.target).closest('#CqaPopupCarousel').length) return;
        if (swipeLocked) return;
        var t = e.originalEvent.touches[0];
        var dx = Math.abs(t.clientX - sx);
        var dy = t.clientY - sy;
        /* First significant movement decides: horizontal → let carousel scroll, vertical → popup drag */
        if (!swipeActive) {
          if (dx > 8 && dx > Math.abs(dy)) { swipeLocked = true; return; }
          if (Math.abs(dy) > 8) { swipeActive = true; }
          else return;
        }
        cy = t.clientY;
        var d = cy - sy;
        if (d > 0) {
          e.preventDefault();
          $pp.css('transform', 'translateY(' + d + 'px)');
        }
      });
      $pp.on('touchend', function () {
        if (swipeLocked) { swipeLocked = false; $pp.removeClass('cqa-popup--dragging'); return; }
        if (!swipeActive) { $pp.removeClass('cqa-popup--dragging'); return; }
        swipeActive = false;
        $pp.removeClass('cqa-popup--dragging');
        if (cy - sy > 80) {
          $pp.css('transform', 'translateY(100%)');
          setTimeout(function () {
            $pp.css('transform', '').removeClass('cqa-popup--visible');
            $('#CqaOverlay').removeClass('cqa-overlay--visible');
            /* Unlock body scroll & restore position */
            var savedY = parseInt(document.body.getAttribute('data-cqa-scroll') || '0', 10);
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            document.body.style.overflow = '';
            window.scrollTo(0, savedY);
          }, 320);
        } else {
          $pp.css('transform', '');
        }
      });

      /* ═════════════════════════════════════════════════
         Prefetch on hover / touchstart (warm cache before click)
         ═════════════════════════════════════════════════ */
      (function () {
        function onInteract(e) {
          if (!e.target || !e.target.closest) return;
          var el = e.target.closest('.collection-quick-add-btn, .cqa-desktop-btn, .grid-product__image-wrapper, .grid-product');
          if (!el) return;
          var handle = el.getAttribute('data-product-handle');
          if (!handle) {
            var btn = el.querySelector('[data-product-handle]');
            if (btn) handle = btn.getAttribute('data-product-handle');
          }
          if (handle) prefetch(handle);
        }
        document.addEventListener('mouseenter', onInteract, true);
        document.addEventListener('touchstart', onInteract, { passive: true, capture: true });
      })();

      /* ═════════════════════════════════════════════════
         Preload visible products during idle time
         ═════════════════════════════════════════════════ */
      (function () {
        /* Keep the network quiet until the customer hovers, touches or clicks a card. */
        var PREFETCH_VISIBLE_PRODUCTS = false;
        if (!PREFETCH_VISIBLE_PRODUCTS) return;
        if (typeof IntersectionObserver === 'undefined') return;
        var idleQueue = [];
        var processing = false;
        function processQueue() {
          if (processing || !idleQueue.length) return;
          processing = true;
          var run = function () {
            var handle = idleQueue.shift();
            if (handle) prefetch(handle);
            if (idleQueue.length) {
              if (window.requestIdleCallback) requestIdleCallback(function () { processing = false; processQueue(); });
              else setTimeout(function () { processing = false; processQueue(); }, 150);
            } else { processing = false; }
          };
          if (window.requestIdleCallback) requestIdleCallback(run);
          else setTimeout(run, 200);
        }
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            io.unobserve(el);
            var handle = el.getAttribute('data-product-handle');
            if (!handle) {
              var btn = el.querySelector('[data-product-handle]');
              if (btn) handle = btn.getAttribute('data-product-handle');
            }
            if (handle && !_cache[handle]) {
              idleQueue.push(handle);
              processQueue();
            }
          });
        }, { rootMargin: '200px' });
        var cards = document.querySelectorAll('.grid-product');
        for (var c = 0; c < cards.length; c++) io.observe(cards[c]);
        /* Also observe new cards from infinite scroll */
        var grid = document.querySelector('.collection-products');
        if (grid) {
          var mo = new MutationObserver(function (muts) {
            muts.forEach(function (m) {
              m.addedNodes.forEach(function (n) {
                if (n.nodeType !== 1) return;
                if (n.matches && n.matches('.grid-product')) io.observe(n);
                var sub = n.querySelectorAll ? n.querySelectorAll('.grid-product') : [];
                for (var s = 0; s < sub.length; s++) io.observe(sub[s]);
              });
            });
          });
          mo.observe(grid, { childList: true, subtree: true });
        }
      })();

      /* ═════════════════════════════════════════════════
         Image swipe gallery on product cards
         ═════════════════════════════════════════════════ */
      (function () {
        var MIN_SWIPE = 30;   /* px threshold for swipe detection */
        var wrappers = document.querySelectorAll('.grid-product__image-wrapper[data-gallery]');
        var nudgePlayed = false;
        var nudgeReserved = false;

        function maybeNudgeFirstCard(wrap) {
          if (nudgePlayed) return;
          if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          nudgePlayed = true;

          function playNudge() {
            if (wrap.classList.contains('cqa-card-gallery--interacted')) return;
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                wrap.classList.add('cqa-card-gallery--nudge');
              });
            });
          }

          var secondSlide = wrap.querySelector('.cqa-card-gallery__track .cqa-card-gallery__slide:nth-child(2)');
          if (secondSlide && secondSlide.tagName && secondSlide.tagName.toLowerCase() === 'img' && !secondSlide.complete) {
            var played = false;
            var done = function () {
              if (played) return;
              played = true;
              window.setTimeout(playNudge, 120);
            };
            secondSlide.addEventListener('load', done, { once: true });
            secondSlide.addEventListener('error', done, { once: true });
            window.setTimeout(done, 900);
          } else {
            window.setTimeout(playNudge, 180);
          }

          wrap.addEventListener('animationend', function (e) {
            if (!e.animationName || e.animationName !== 'cqaCardGalleryNudge') return;
            wrap.classList.remove('cqa-card-gallery--nudge');
          }, { once: true });
        }

        function initCard(wrap) {
          var raw = wrap.getAttribute('data-gallery');
          if (!raw) return;
          var template = wrap.querySelector('.cqa-card-gallery-template');
          var templateSlides = [];
          if (template && template.content) {
            templateSlides = Array.prototype.slice.call(template.content.children);
          }
          var imgs = [];
          if (!templateSlides.length && raw !== 'media') {
            imgs = raw.split('|||').filter(function (src) { return !!src; });
          }
          if (templateSlides.length < 2 && imgs.length < 2) return;

          if (wrap.getAttribute('data-gallery-ready') === '1') return;
          wrap.setAttribute('data-gallery-ready', '1');

          var idx = 0;
          var sx = 0, ex = 0, sxY = 0, locked = false, deltaX = 0;
          var imgEl = wrap.querySelector('.product--image, .grid-product__image');
          if (!imgEl) return;
          var serverTrack = wrap.querySelector('.cqa-card-gallery__track[data-cqa-server-track]');
          var imgParent = serverTrack && serverTrack.contains(imgEl) ? serverTrack.parentNode : imgEl.parentNode;
          imgParent.style.position = 'relative';
          if (imgEl.tagName && imgEl.tagName.toLowerCase() === 'video') {
            try { imgEl.pause(); } catch (e) {}
            imgEl.classList.remove('cqa-card-video');
          }

          wrap.classList.add('cqa-card-gallery');

          var track = serverTrack || document.createElement('div');
          track.className = 'cqa-card-gallery__track';

          function prepareSlide(slide, eager) {
            if (slide.tagName && slide.tagName.toLowerCase() === 'img') {
              slide.classList.add('cqa-card-gallery__slide');
              if (eager && !slide.getAttribute('src') && slide.getAttribute('data-src')) {
                slide.setAttribute('src', slide.getAttribute('data-src'));
                slide.removeAttribute('data-src');
              }
              slide.loading = eager ? 'eager' : 'lazy';
              if (!eager) slide.setAttribute('fetchpriority', 'low');
              slide.draggable = false;
              slide.decoding = 'async';
              return;
            }

            if (!eager && slide.style && slide.style.backgroundImage) {
              slide.setAttribute('data-cqa-background-image', slide.style.backgroundImage);
              slide.style.removeProperty('background-image');
            }

            var videos = slide.querySelectorAll ? slide.querySelectorAll('video') : [];
            for (var vi = 0; vi < videos.length; vi++) {
              if (!eager && videos[vi].getAttribute('poster')) {
                videos[vi].setAttribute('data-cqa-poster', videos[vi].getAttribute('poster'));
                videos[vi].removeAttribute('poster');
              }
              videos[vi].muted = true;
              videos[vi].loop = true;
              videos[vi].playsInline = true;
              videos[vi].autoplay = false;
              videos[vi].preload = 'none';
              videos[vi].removeAttribute('controls');
            }
          }

          /* Reuse the server-rendered first image when it matches the gallery.
             This preserves LCP discovery and avoids downloading a duplicate
             first slide while retaining the existing swipe sequence. */
          var isPriorityCard = wrap.getAttribute('data-cqa-lcp') === 'true';
          function imageKey(url) {
            return String(url || '')
              .split('?')[0]
              .replace(/^https?:\/\/[^/]+/i, '')
              .replace(/^\/\/[^/]+/i, '')
              .replace(/_\d+x(?:\d+)?(?=\.[a-z0-9]+$)/i, '');
          }
          var firstTemplateImage = null;
          for (var templateImageIndex = 0; templateImageIndex < templateSlides.length; templateImageIndex++) {
            if (templateSlides[templateImageIndex].tagName && templateSlides[templateImageIndex].tagName.toLowerCase() === 'img') {
              firstTemplateImage = templateSlides[templateImageIndex];
              break;
            }
          }
          var primaryImageKey = imageKey(imgEl.currentSrc || imgEl.getAttribute('src'));
          var templateMatchesPrimary = !!(primaryImageKey && firstTemplateImage &&
            imageKey(firstTemplateImage.getAttribute('data-src')) === primaryImageKey);
          var reusePrimary = imgEl.tagName && imgEl.tagName.toLowerCase() === 'img' &&
            ((serverTrack && serverTrack.contains(imgEl)) || isPriorityCard || templateMatchesPrimary);
          if (reusePrimary) {
            prepareSlide(imgEl, isPriorityCard);
            if (imgEl.parentNode !== track) track.appendChild(imgEl);
          }

          if (templateSlides.length) {
            templateSlides.forEach(function (node, templateIndex) {
              if (reusePrimary && templateMatchesPrimary && node === firstTemplateImage) return;
              var slide = node.cloneNode(true);
              prepareSlide(slide, track.children.length < 1);
              track.appendChild(slide);
            });
          } else {
            imgs.forEach(function (src) {
            var slide = document.createElement('img');
            slide.className = 'cqa-card-gallery__slide';
            if (track.children.length < 1) {
              slide.src = src;
              slide.loading = 'eager';
            } else {
              slide.setAttribute('data-src', src);
              slide.loading = 'lazy';
              slide.setAttribute('fetchpriority', 'low');
            }
            slide.alt = '';
            slide.draggable = false;
            slide.decoding = 'async';
            track.appendChild(slide);
            });
          }
          var slideCount = track.children.length;
          if (slideCount < 2) return;
          /* Keep the logical slide in the DOM so the video observer can avoid
             downloading media that is only exposed by the automatic nudge. */
          wrap.setAttribute('data-cqa-gallery-index', '0');
          var shouldPreloadNudgeSlide = !nudgeReserved && !nudgePlayed &&
            window.matchMedia &&
            window.matchMedia('(max-width: 768px)').matches &&
            !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (shouldPreloadNudgeSlide) nudgeReserved = true;
          ensureLoaded(0);
          if (track.parentNode !== imgParent) imgParent.appendChild(track);
          if (shouldPreloadNudgeSlide) {
            var queueNudge = function () {
              var runNudge = function () {
                ensureLoaded(1);
                maybeNudgeFirstCard(wrap);
              };
              if (window.requestIdleCallback) window.requestIdleCallback(runNudge, { timeout: 1500 });
              else window.setTimeout(runNudge, 300);
            };
            if (document.readyState === 'complete') queueNudge();
            else window.addEventListener('load', queueNudge, { once: true });
          }

          function ensureLoaded(i) {
            var slide = track.children[i];
            if (!slide) return;
            if (!slide.getAttribute('src') && slide.getAttribute('data-src')) {
              slide.setAttribute('src', slide.getAttribute('data-src'));
              slide.removeAttribute('data-src');
            }
            if (slide.getAttribute('data-cqa-background-image')) {
              slide.style.backgroundImage = slide.getAttribute('data-cqa-background-image');
              slide.removeAttribute('data-cqa-background-image');
            }
            var videos = slide.querySelectorAll ? slide.querySelectorAll('video[data-cqa-poster]') : [];
            for (var vi = 0; vi < videos.length; vi++) {
              videos[vi].setAttribute('poster', videos[vi].getAttribute('data-cqa-poster'));
              videos[vi].removeAttribute('data-cqa-poster');
            }
          }

          function moveTo(i, animate, offsetPx) {
            var w = imgParent.clientWidth || wrap.clientWidth || 1;
            track.style.transition = animate ? '' : 'none';
            track.style.transform = 'translate3d(' + ((-i * w) + (offsetPx || 0)) + 'px,0,0)';
          }

          function show(i) {
            idx = i;
            wrap.setAttribute('data-cqa-gallery-index', String(idx));
            ensureLoaded(idx);
            ensureLoaded(idx + 1);
            moveTo(idx, true, 0);
            wrap.dispatchEvent(new CustomEvent('verychi:cqa-gallery-change', {
              bubbles: true,
              detail: { index: idx }
            }));
          }

          wrap.addEventListener('touchstart', function (e) {
            wrap.classList.remove('cqa-card-gallery--nudge');
            var t = e.touches[0];
            sx = ex = t.clientX;
            sxY = t.clientY;
            locked = false;
            deltaX = 0;
          }, { passive: true });

          wrap.addEventListener('touchmove', function (e) {
            ex = e.touches[0].clientX;
            deltaX = ex - sx;
            /* Lock to horizontal if swipe is clearly horizontal */
            if (!locked && Math.abs(deltaX) > 10 && Math.abs(deltaX) > Math.abs(e.touches[0].clientY - sxY) * 1.2) {
              locked = true;
            }
            if (locked) {
              e.preventDefault();
              var atFirst = idx === 0 && deltaX > 0;
              var atLast = idx === slideCount - 1 && deltaX < 0;
              if (deltaX < 0) ensureLoaded(idx + 1);
              else ensureLoaded(idx - 1);
              moveTo(idx, false, (atFirst || atLast) ? deltaX * 0.25 : deltaX);
            }
          }, { passive: false });

          wrap.addEventListener('touchend', function (e) {
            var dx = deltaX;
            if (!locked) return;
            if (Math.abs(dx) < MIN_SWIPE) {
              moveTo(idx, true, 0);
              return;
            }
            e.preventDefault();
            e.stopPropagation();
            wrap.classList.add('cqa-card-gallery--interacted');
            if (dx < 0) { show(Math.min(idx + 1, slideCount - 1)); }
            else        { show(Math.max(idx - 1, 0)); }
          }, { passive: false });

          window.addEventListener('resize', function () {
            moveTo(idx, false, 0);
          }, { passive: true });
        }

        /* Build swipe galleries only near the viewport. This preserves the
           first swipe while avoiding two eager image requests for every card. */
        var galleryObserver = null;
        if (typeof IntersectionObserver !== 'undefined') {
          galleryObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              galleryObserver.unobserve(entry.target);
              initCard(entry.target);
            });
          }, { rootMargin: '300px 0px' });
        }

        function observeCard(wrap) {
          if (!wrap) return;
          if (galleryObserver) galleryObserver.observe(wrap);
          else initCard(wrap);
        }

        /* Init existing cards */
        for (var i = 0; i < wrappers.length; i++) observeCard(wrappers[i]);

        /* Observe for infinite-scroll new cards */
        var obs = new MutationObserver(function (muts) {
          muts.forEach(function (m) {
            m.addedNodes.forEach(function (n) {
              if (n.nodeType !== 1) return;
              var gals = n.querySelectorAll ? n.querySelectorAll('.grid-product__image-wrapper[data-gallery]') : [];
              for (var j = 0; j < gals.length; j++) observeCard(gals[j]);
              if (n.matches && n.matches('.grid-product__image-wrapper[data-gallery]')) observeCard(n);
            });
          });
        });
        var grid = document.querySelector('.collection-products');
        if (grid) obs.observe(grid, { childList: true, subtree: true });
      })();

      /* ═════════════════════════════════════════════════
         Desktop/mobile card videos: play only while visible
         ═════════════════════════════════════════════════ */
      (function () {
        var videos = document.querySelectorAll('.collection-products .cqa-card-video');

        function markReady(video) {
          video.classList.add('cqa-card-video--ready');
        }

        function prepare(video) {
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          video.autoplay = false;
          video.preload = 'none';
          video.removeAttribute('controls');

          if (video.getAttribute('data-cqa-video-prepared') === '1') return;
          video.setAttribute('data-cqa-video-prepared', '1');

          if (video.readyState >= 2) {
            markReady(video);
          } else {
            video.addEventListener('loadeddata', function () { markReady(video); }, { once: true });
            video.addEventListener('canplay', function () { markReady(video); }, { once: true });
            video.addEventListener('playing', function () { markReady(video); }, { once: true });
          }
        }

        /* A gallery's off-screen slides still have viewport coordinates and
           can briefly intersect while the first-card nudge runs. Only the
           customer-selected slide may start its (often multi-megabyte)
           video; the poster remains visible during the nudge. */
        function belongsToActiveGallerySlide(video) {
          var gallerySlide = video.closest ? video.closest('.cqa-card-gallery__slide') : null;
          if (!gallerySlide) return true;
          var galleryTrack = gallerySlide.parentNode;
          var galleryWrap = gallerySlide.closest('.grid-product__image-wrapper[data-gallery]');
          var galleryIndex = galleryTrack ? Array.prototype.indexOf.call(galleryTrack.children, gallerySlide) : -1;
          var activeIndex = galleryWrap ? parseInt(galleryWrap.getAttribute('data-cqa-gallery-index') || '0', 10) : 0;
          return galleryIndex === activeIndex;
        }

        function playVideo(video) {
          prepare(video);
          if (!belongsToActiveGallerySlide(video)) {
            video.pause();
            return;
          }

          video.preload = 'auto';
          var promise = video.play();
          if (promise && typeof promise.catch === 'function') {
            promise.catch(function () {});
          }
        }

        function pauseVideo(video) {
          video.pause();
        }

        if (typeof IntersectionObserver === 'undefined') {
          for (var i = 0; i < videos.length; i++) prepare(videos[i]);
          return;
        }

        var videoObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio > 0.45) {
              playVideo(video);
            } else {
              pauseVideo(video);
            }
          });
        }, { threshold: [0, 0.45, 0.75] });

        for (var v = 0; v < videos.length; v++) {
          prepare(videos[v]);
          videoObserver.observe(videos[v]);
        }

        document.addEventListener('verychi:cqa-gallery-change', function (event) {
          var wrap = event.target && event.target.closest ? event.target.closest('.grid-product__image-wrapper[data-gallery]') : null;
          if (!wrap) return;
          var galleryVideos = wrap.querySelectorAll('.cqa-card-video');
          for (var i = 0; i < galleryVideos.length; i++) {
            if (belongsToActiveGallerySlide(galleryVideos[i])) playVideo(galleryVideos[i]);
            else pauseVideo(galleryVideos[i]);
          }
        });

        var gridVideos = document.querySelector('.collection-products');
        if (gridVideos) {
          var videoMo = new MutationObserver(function (muts) {
            muts.forEach(function (m) {
              m.addedNodes.forEach(function (n) {
                if (n.nodeType !== 1) return;
                var found = [];
                if (n.matches && n.matches('.cqa-card-video')) found.push(n);
                var sub = n.querySelectorAll ? n.querySelectorAll('.cqa-card-video') : [];
                for (var s = 0; s < sub.length; s++) found.push(sub[s]);
                for (var f = 0; f < found.length; f++) {
                  prepare(found[f]);
                  videoObserver.observe(found[f]);
                }
              });
            });
          });
          videoMo.observe(gridVideos, { childList: true, subtree: true });
        }
      })();

      window.__verychiCqaReady = true;
      document.dispatchEvent(new CustomEvent('verychi:cqa-ready'));
    }); /* end $(function) */
  } /* end boot() */

  /* Start: if DOM ready, boot now; otherwise wait */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
